import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { fileUrl } from "@/api";
import { Reveal } from "./Page";

const localized = (value, lang, fallback = "") => {
  if (value == null) return fallback;

  if (typeof value === "string" || typeof value === "number") {
    return value;
  }

  if (typeof value === "object") {
    return value[lang] ?? value.tr ?? value.en ?? fallback;
  }

  return fallback;
};

export const ProjectCard = ({ project, index, wide = false }) => {
  const { lang } = useLang();

  const title = localized(project?.title, lang, "");
  const location = localized(project?.location, lang, "");
  const category = localized(project?.category, lang, "");
  const year = localized(project?.year, lang, "");

  return (
    <Reveal>
      <Link
        to={`/projects/${project.id}`}
        data-testid={`project-card-${project.id}`}
        className="group block"
      >
        <div className="overflow-hidden bg-stone">
          <img
            src={fileUrl(project.cover)}
            alt={title}
            loading={index > 1 ? "lazy" : "eager"}
            className={`w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.035] ${
              wide ? "h-[62vh] md:h-[86vh]" : "aspect-[3/4]"
            }`}
          />
        </div>

        <div className="mt-5 flex items-start justify-between gap-6">
          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-clay">
              {String(index + 1).padStart(2, "0")}
            </span>

            <h3 className="mt-2 text-lg sm:text-xl font-light uppercase tracking-tight">
              {title}
            </h3>
          </div>

          <div className="text-right font-mono text-[10px] uppercase tracking-[0.22em] text-clay leading-relaxed">
            <div>{location}</div>

            <div>
              {year}
              {year && category ? " — " : ""}
              {category}
            </div>
          </div>
        </div>
      </Link>
    </Reveal>
  );
};
